import { useTranslation } from "@redotech/redo-i18n";
import XIcon from "@redotech/redo-icons/x-close.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, ReactNode } from "react";

/** Read-only right-panel shell shared by the HSA questionnaire inspectors. */
export const HsaInspectorShell = memo(function HsaInspectorShell({
  title,
  subtitle,
  onClose,
  children,
}: {
  title: string;
  subtitle?: string;
  onClose?: () => void;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <Flex dir="column" gap="3xl" p="3xl">
      <Flex align="flex-start" justify="space-between" py="sm">
        <Flex dir="column" gap="xxs">
          <Text fontSize="sm" fontWeight="semibold">
            {title}
          </Text>
          {subtitle && (
            <Text fontSize="xs" textColor="secondary">
              {subtitle}
            </Text>
          )}
        </Flex>
        {onClose && (
          <RedoButton
            aria-label={t("Close")}
            hierarchy="tertiary"
            IconLeading={XIcon}
            onClick={onClose}
            size="sm"
          />
        )}
      </Flex>
      {children}
    </Flex>
  );
});
